import { Box } from '@mui/material'
import { useBreadcrumbPortalContext } from './BreadcrumbPortalProvider'

export default function BreadcrumbPortal() {
  const [, setPortalNode] = useBreadcrumbPortalContext()
  return (
    <nav aria-label="Breadcrumb">
      <Box sx={{ display: 'flex', px: 0.5, mt: 1 }} ref={setPortalNode} />
    </nav>
  )
}
